interface DeliveryFeeRefundCheckboxProps {
  /** VAT-inclusive fee charged on this order. Nothing renders when it is null/0. */
  feeCharged: number | null | undefined;
  trips?: number | null;
  currency: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/**
 * Spec 053 Flow F5 / BR-25 — "also refund the pickup & delivery fee".
 *
 * <p>Shown only when the order actually carries a fee, with the amount stated on the label so the
 * admin never has to go and look it up. The fee is Garagat's own supply, not the garage's, so
 * refunding it issues a credit note against Garagat's invoice (PCN) and never touches the garage's
 * commission — the wording says so rather than leaving the admin to infer it.
 */
export default function DeliveryFeeRefundCheckbox({
  feeCharged,
  trips,
  currency,
  checked,
  onChange,
  disabled,
}: DeliveryFeeRefundCheckboxProps) {
  if (feeCharged == null || feeCharged <= 0) return null;

  return (
    <div className="admin-form-group" data-testid="refund-delivery-fee-field">
      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        Refund the pickup &amp; delivery fee too (
        <span style={{ fontVariantNumeric: 'tabular-nums' }}>
          {currency} {feeCharged.toFixed(2)}
        </span>
        {trips != null && trips > 0 ? `, ${trips} trip${trips === 1 ? '' : 's'}` : ''})
      </label>
      <p style={{ fontSize: '0.8125rem', color: 'var(--admin-text-muted)', margin: '0.25rem 0 0 1.5rem' }}>
        Garagat&apos;s own supply — refunding it issues a credit note against Garagat&apos;s invoice
        and does not affect the garage&apos;s commission.
      </p>
    </div>
  );
}
